/** =========================================================
 * Module: items-top-buttons.directive.js
 * Items top buttons
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.components')
    .directive('itemsTopButtons', itemsTopButtons);

  itemsTopButtons.$inject = [];

  function itemsTopButtons() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/components/items-top-buttons.html',
      link: link,
      scope: {
        config: '='
      }
    };

    return directive;

    function link($scope) {
      $scope.data = $scope.config && $scope.config.hasOwnProperty('topButtons') ? $scope.config.topButtons : [];

      $scope.tryFunction = function (item, field, fieldItem) {
        try {
          return typeof field[fieldItem] === 'function' ? field[fieldItem](item) : field[fieldItem];
        } catch (error) {
          Raven.captureException(error);
        }

        return '';
      };
    }
  }
})();
